import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NgClass, NgFor } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FlexModule } from '@angular/flex-layout/flex';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyOptionModule } from '@angular/material/legacy-core';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import {
  Countertop,
  CuttingButt,
  LegacyDialogsService,
  MaterialBaseButtsDialogComponent,
  MaterialBaseEdgeDialogData,
  getFullCountertopThickness,
} from 'cloud-shared-lib';

@Component({
  selector: 'csl-butt-select',
  templateUrl: './butt-select.component.html',
  standalone: true,
  imports: [
    FlexModule,
    MatLegacyFormFieldModule,
    NgClass,
    ExtendedModule,
    MatLegacySelectModule,
    FormsModule,
    MatLegacyOptionModule,
    NgFor,
    MatLegacyButtonModule,
    MatIconModule,
  ],
})
export class ButtSelectComponent {
  _butt: CuttingButt = undefined;

  @Input() set selected(val: CuttingButt) {
    this._butt = val;
  }
  @Input() butts: CuttingButt[] = [];
  @Input() countertop: Countertop;
  @Input() disabled = false;
  @Input() editable = true;
  @Output() selectedChange: EventEmitter<CuttingButt> = new EventEmitter<CuttingButt>();

  @Input()
  get dense(): boolean {
    return this._dense;
  }
  set dense(value: BooleanInput) {
    this._dense = coerceBooleanProperty(value);
  }
  _dense = false;

  constructor(public dialogs: LegacyDialogsService) {}

  onButtChange(): void {
    this.selectedChange.emit(this._butt);
  }

  openMaterialBaseDialog(): void {
    this.dialogs
      .component(
        MaterialBaseButtsDialogComponent,
        {
          panelThickness: getFullCountertopThickness(this.countertop),
        } as MaterialBaseEdgeDialogData,
        1000
      )
      .subscribe((result: CuttingButt | undefined) => {
        if (result) {
          this.butts.push(result);
          this._butt = result;
          this.onButtChange();
        }
      });
  }
}
